"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Sort = _interopRequireDefault(require("@insided/shared/icons/Sort"));

var _iconArrowDropUp = _interopRequireDefault(require("@insided/legacy-icons/icon-arrow-drop-up"));

var _iconArrowDropDown = _interopRequireDefault(require("@insided/legacy-icons/icon-arrow-drop-down"));

var Sorting = function Sorting(_ref) {
  var isEnabled = _ref.isEnabled,
      direction = _ref.direction;

  if (isEnabled && direction === 'asc') {
    return (0, _preact.h)(_iconArrowDropUp.default, {
      width: 16,
      height: 16
    });
  }

  if (isEnabled && direction === 'desc') {
    return (0, _preact.h)(_iconArrowDropDown.default, {
      width: 16,
      height: 16
    });
  }

  return (0, _preact.h)(_Sort.default, {
    height: 16,
    width: 16,
    className: "inactive"
  });
};

var _default = Sorting;
exports.default = _default;